// collectionOperationDashboard/api/index.js
import request from '@/utils/request';

const baseURLAdmin = process.env.VUE_APP_ADMIN;
// 地址服务（modules-address）网关前缀，cep 州/城市下拉数据源
const baseURLAddress = process.env.VUE_APP_ADDRESS;

/**
 * 获取揽收运营数据
 */
export function getCollectionDashboard(params) {
  return request({
    url: '/dashboard/collection',
    method: 'get',
    params
  });
}

/**
 * 导出城市明细
 */
export function exportCityDetail(params) {
  return request({
    url: '/dashboard/collection/export',
    method: 'get',
    params,
    responseType: 'blob'
  });
}

/**
 * FM揽收运营数据看板————KPI指标卡（六卡+数据更新时间）
 * @param {Object} data
 * @param {string} data.startDate - 开始日期 yyyy-MM-dd
 * @param {string} data.endDate - 结束日期 yyyy-MM-dd
 * @param {string} data.platform - 平台
 * @param {string} data.serviceType - 服务类型
 * @param {string} data.stateCode - 州代码
 * @param {string} data.cityName - 城市名
 * @param {Array<number>} data.siteIds - 站点ID数组
 */
export const getFmCollectKpi = (data) => {
  return request({
    url: `/fmCollectDashboard/kpi`,
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};

/**
 * FM揽收运营数据看板————揽收趋势（固定最近7天不受时间筛选影响；客户/服务类型/UF/城市/HUB 筛选生效）
 * @param {Object} data - 与其他查询接口一致的筛选条件
 */
export const getFmCollectTrend = (data) => {
  return request({
    url: `/fmCollectDashboard/trend`,
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};

/**
 * FM揽收运营数据看板————按客户统计揽收量（四桶固定顺序）
 * @param {Object} data
 * @param {string} data.startDate - 开始日期
 * @param {string} data.endDate - 结束日期
 * @param {string} data.platform - 平台
 * @param {string} data.serviceType - 服务类型
 * @param {string} data.stateCode - 州代码
 * @param {string} data.cityName - 城市名
 * @param {Array<number>} data.siteIds - 站点ID数组
 */
export const getFmCollectCustomerChart = (data) => {
  return request({
    url: `/fmCollectDashboard/customerChart`,
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};

/**
 * FM揽收运营数据看板————按服务类型统计揽收量
 * @param {Object} data
 * @param {string} data.startDate - 开始日期
 * @param {string} data.endDate - 结束日期
 * @param {string} data.platform - 平台
 * @param {string} data.serviceType - 服务类型
 * @param {string} data.stateCode - 州代码
 * @param {string} data.cityName - 城市名
 * @param {Array<number>} data.siteIds - 站点ID数组
 */
export const getFmCollectServiceChart = (data) => {
  return request({
    url: `/fmCollectDashboard/serviceChart`,
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};

/**
 * FM揽收运营数据看板————按UF统计揽收表现（Top10+其他UF）
 * @param {Object} data
 * @param {string} data.startDate - 开始日期
 * @param {string} data.endDate - 结束日期
 * @param {string} data.platform - 平台
 * @param {string} data.serviceType - 服务类型
 * @param {string} data.stateCode - 州代码
 * @param {string} data.cityName - 城市名
 * @param {Array<number>} data.siteIds - 站点ID数组
 */
export const getFmCollectUfChart = (data) => {
  return request({
    url: `/fmCollectDashboard/ufChart`,
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};

/**
 * FM揽收运营数据看板————按州×客户揽收量（地图州内饼图、第一大客户）
 * @param {Object} data
 * @param {string} data.startDate - 开始日期
 * @param {string} data.endDate - 结束日期
 * @param {string} data.platform - 平台
 * @param {string} data.serviceType - 服务类型
 * @param {string} data.stateCode - 州代码
 * @param {string} data.cityName - 城市名
 * @param {Array<number>} data.siteIds - 站点ID数组
 */
export const getFmCollectUfCustomerChart = (data) => {
  return request({
    url: `/fmCollectDashboard/ufCustomerChart`,
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};

/**
 * FM揽收运营数据看板————城市明细分页（客户×城市+城市小计行）
 * @param {Object} data
 * @param {number} data.pageNumber - 页码
 * @param {number} data.pageSize - 每页条数
 * @param {Object} data.params - 查询参数
 * @param {string} data.params.startDate - 开始日期
 * @param {string} data.params.endDate - 结束日期
 * @param {string} data.params.platform - 平台
 * @param {string} data.params.serviceType - 服务类型
 * @param {string} data.params.stateCode - 州代码
 * @param {string} data.params.cityName - 城市名
 * @param {Array<number>} data.params.siteIds - 站点ID数组
 */
export const getFmCollectCityDetail = (data) => {
  return request({
    url: `/fmCollectDashboard/cityDetail`,
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};

/**
 * 巴西邮政DNE————全部州（缩写列表，服务端带缓存）
 * 看板 UF 下拉数据源（替代原 lg_area 接口）
 */
/**
 * 网点档案————全部转运中心（site_type=3），不传status=含停用
 * 看板 HUB 下拉数据源（需求：默认选择转运中心……默认展示所有hub，关闭的hub只会查询不到数据）
 */
export const getTransitCenterAll = () => {
  return request({
    url: `/site/getTransitCenterAll`,
    method: 'get',
    baseURL: baseURLAdmin
  });
};

export const getCepStates = () => {
  return request({
    url: `/cep/states`,
    method: 'get',
    baseURL: baseURLAddress
  });
};

/**
 * 巴西邮政DNE————城市搜索（服务端过滤，支持不选州全局搜）
 * 看板城市下拉数据源：输入关键词远程搜索（包含匹配），未选州时跨州全局搜
 * @param {Object} params - { state: 州二字码(可选), city: 关键词(可选), size: 返回条数(默认50,上限200) }
 */
export const getCepCities = (params) => {
  return request({
    url: `/cep/cities`,
    method: 'get',
    params,
    baseURL: baseURLAddress
  });
};

/**
 * FM揽收运营数据看板————城市明细导出（含小计行）
 * @param {Object} data
 * @param {string} data.startDate - 开始日期
 * @param {string} data.endDate - 结束日期
 * @param {string} data.platform - 平台
 * @param {string} data.serviceType - 服务类型
 * @param {string} data.stateCode - 州代码
 * @param {string} data.cityName - 城市名
 * @param {Array<number>} data.siteIds - 站点ID数组
 */
export const exportFmCollectCityDetail = (data) => {
  return request({
    url: `/fmCollectDashboard/export/cityDetail`,
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};

/**
 * FM揽收运营数据看板————Miss Scan清单导出
 * @param {Object} data
 * @param {string} data.startDate - 开始日期
 * @param {string} data.endDate - 结束日期
 * @param {string} data.platform - 平台
 * @param {string} data.serviceType - 服务类型
 * @param {string} data.stateCode - 州代码
 * @param {string} data.cityName - 城市名
 * @param {Array<number>} data.siteIds - 站点ID数组
 */
export const exportFmCollectMissScanList = (data) => {
  return request({
    url: `/fmCollectDashboard/export/missScanList`,
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};

/**
 * FM揽收运营数据看板————当天未完成装车清单导出
 * @param {Object} data
 * @param {string} data.startDate - 开始日期
 * @param {string} data.endDate - 结束日期
 * @param {string} data.platform - 平台
 * @param {string} data.serviceType - 服务类型
 * @param {string} data.stateCode - 州代码
 * @param {string} data.cityName - 城市名
 * @param {Array<number>} data.siteIds - 站点ID数组
 */
export const exportFmCollectUnloadedList = (data) => {
  return request({
    url: `/fmCollectDashboard/export/unloadedList`,
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
